export class SdVertex {
    get Prev() {
        if (this.PrevEdge == null) {
            return null;
        }
        return this.PrevEdge.Source === this ? this.PrevEdge.Target : this.PrevEdge.Source;
    }
    constructor(visibilityVertex) {
        this.InBoneEdges = new Array();
        this.OutBoneEdges = new Array();
        this.VisibilityVertex = visibilityVertex;
    }
    get Point() {
        return this.VisibilityVertex.point;
    }
    get Cost() {
        if (this.IsSourceOfRouting) {
            return this.cost;
        }
        return this.Prev == null ? Number.POSITIVE_INFINITY : this.cost;
    }
    set Cost(value) {
        this.cost = value;
    }
    SetPreviousToNull() {
        this.PrevEdge = null;
    }
}
//# sourceMappingURL=SdVertex.js.map